export const APP = {
  NAME: {
    FA: "ریبیکس",
    EN: "Rebix",
  },
  NAME_COMMERTIAL: {
    FA: "ریـــبـیـــکــس",
    EN: "REBIX",
  },
  LANG: {
    FA: {
      NAME: "Persian",
      COUNTRY: "IRAN",
      CODE: "fa-ir,fa",
    },
  },
};

export const USERGROUPS = {
  GROUP_USER: "User",
  GROUP_USER_CODE: "GROUP_USER",
  GROUP_COMPANYEMPLOYEE_WEBSITEADMIN: "Website Admin",
  GROUP_COMPANYEMPLOYEE_FINANCIALDEPARTMENT: "Financial expert",
  GROUP_COMPANYEMPLOYEE_SUPPORTDEPARTMENT: "Support expert",
  GROUP_COMPANYEMPLOYEE_DEVDEPARTMENT: "Dev expert",
  GROUP_COMPANYOFFICE: "Company management office",
  GROUP_COMPANYEMPLOYEE: "Company expert",
  FA: {
    GROUP_USER: "کاربر سامانه",
    GROUP_COMPANYEMPLOYEE_WEBSITEADMIN: "ادمین سایت",
    GROUP_COMPANYEMPLOYEE_FINANCIALDEPARTMENT: "کارشناس دپارتمان مالی",
    GROUP_COMPANYEMPLOYEE_SUPPORTDEPARTMENT: "کارشناس دپارتمان پشتیبانی",
    GROUP_COMPANYEMPLOYEE_DEVDEPARTMENT: "کارشناس دپارتمان توسعه",
    GROUP_COMPANYOFFICE: "دفتر مدیریت شرکت",
    GROUP_COMPANYEMPLOYEE: "کارشناس شرکت",
  },
};

export const ACCESSLEVELS = {
  STARTED: "Started",
  AUTHENTICATED: "Authenticated",
  LEVEL_AUTH: "LEVEL_AUTH",
  FA: {
    STARTED: "تازه کار",
    AUTHENTICATED: "احراز شده",
  },
};

export const EXCEPTS = {
  NOT_VALID_COOKIE: "CookieIsNotValid",
};

export const CORE = {
  // API_URL: "http://localhost:8000/",
  API_URL: "https://rebix.ir:8000/",
  API_ACCESS_TOKEN:
    "AmbPfgJIWYIAka1wRCCXgCvGGsJgMl8t2vnvjubvipjMDtn5j18D46y0Q5ZnSI1D9doQfIOHUi9cKOFUvV1fnJpXWxzd2UWpDkngc5ptbloAUDJKJcyQUDHy",
  GOOGLE_CREDENTIAL_API:
    "250150747493-k0j485m45il8qjfdf03jkg69diinr2hc.apps.googleusercontent.com",
};

export const COOKIE = {
  COR: {
    U: "CNF_COrU_TOKEN",
  },
};

export const REQUEST = {
  HEADERS: {
    USERMETA: "RX-USER-META",
  },
};

export const RESPONSE = {
  JSON_OBJECTS: {
    REPONSE_CODE: "code",
    RESPONSE_DATA: "data",
    RESPONSE_MESSAGE: "message",
  },
  CODE: {
    SUCCESS: "OK",
  },
};

export const LINKS = {
  API_GEOLOCATION: "https://geolocation-db.com/",
  APP: {
    MAIN: "/",
    EXTERNAL_LINKS: "/externalink",
    CREATE_ACCOUNT: "/auth/sign/:referral?",
    LOGIN_ACCOUNT: "/auth/login",
    FORGOT: {
      MAIN: "/auth/forgot/change/:idt",
      SEND: "/auth/forgot/send",
    },
    DASHBOARD: "/dashboard",
    SEARCH: "/search/",

    DOWNLOAD: {
      DIRECT_ANDROID: "/_ragc/files/android/direct_android.apk",
      GOOGLEPLAY_ANDROID:
        "https://play.google.com/store/apps/details?id=io.rebix.app.android",
      CAFEBAZZAR_ANDROID: "https://cafebazaar.ir/app/io.rebix.app.android",
    },

    WALLET: {
      MAIN: "/wallet",
      DEPOSIT: "/wallet/deposit/:address/:symbol",
      WITHDRAW: "/wallet/withdraw/:address/:symbol",
      BUY: "/wallet/buy/:address/:symbol",
      SELL: "/wallet/sell/:address/:symbol",
    },
    ADDRESS: "/address/:address/:symbol",

    SWAP: "/swap",
    TICKET: {
      MAIN: "/tickets",
      DETAILS: "/tickets/details/:id",
      CREATE: "/tickets/create/:id?",
    },
    FINANCE: {
      MAIN: "/finance",
      ACCOUNT: {
        CREATE: "/finance/accounts/create",
      },
    },
    PRICES: "/prices",
    ABOUT: "/about",
    LIVESUPPORT: "/live-support",
    TERM_OF_USE: "/terms",
    ACCOUNT: {
      MAIN: "/account",
      SETTINGS: {
        MAIN: "/account/settings",
        PROFILE: "/account/settings/profile",
        AUTHENTICATION: "/account/settings/authentication",
      },
      SECURITY: "/account/security",
    },
    COREVIEW: {
      MAIN: "/coreview",
      IPG: {
        PAYPING: "/coreview/ipg/payping/:txaddress",
        ZARINPAL: "/coreview/ipg/zarinpal/:txaddress",
        NOVINOPAY: "/coreview/ipg/novinopay/:txaddress",
      },
    },
  },
  CORE: {
    USER: {
      CREATE_ACCOUNT: "/app/useraccount/new/",
      CREATE_ACCOUNT_CREDENTIAL: {
        GOOGLE: "/app/useraccount/new/credential/google/",
      },
      CONFIRM_NEWACCOUNT: "/app/useraccount/new/confirm/",
      COMPLETE_ACCOUNT_CREATION: "/app/useraccount/new/complete/",
      LOGIN_ACCOUNT: "/app/useraccount/login/",
      LOGIN_ACCOUNT_CREDENTIAL: {
        GOOGLE: "/app/useraccount/login/credential/google/",
      },
      LOGOUT_ACCOUNT: "/app/useraccount/logout/",
      FORGOT: "/app/useraccount/forgot/",
      FORGOT_CHANGE: "/app/useraccount/forgot/change/",
      CONFIRM_LOGINACCOUNT: "/app/useraccount/login/confirm/",
      AUTHENTICATE_ACCESSTOKEN: "/app/useraccount/auth/accesstoken/",
      SEARCH: "/app/search/",
      PUBLIC: {
        STATISTICS: "/app/public/statistics/",
        PRICE: {
          CHANGES: {
            MAIN: "/app/public/price/changes/",
            TOP: "/app/public/price/changes/top/",
          },
        },
      },
      TICKET: {
        LIST: "/app/ticket/list/",
        CREATE: "/app/ticket/create/",
        PRECREATE: "/app/ticket/precreate/",
        DETAILS: "/app/ticket/details/",
      },
      SETTINGS: {
        PROFILE: {
          INFO: "/app/useraccount/profile/info/",
          UPDATE: "/app/useraccount/profile/update/",
        },
        AUTHENTICATION: {
          INFO: "/app/useraccount/authentication/info/",
          UPDATE: "/app/useraccount/authentication/update/",
        },
      },
      CONNECT: {
        MOBILE: {
          SENDCODE: "/app/useraccount/connect/mobile/sendcode/",
          CONFIRM: "/app/useraccount/connect/mobile/confirm/",
        },
        EMAIL: {
          SENDCODE: "/app/useraccount/connect/email/sendcode/",
          CONFIRM: "/app/useraccount/connect/email/confirm/",
        },
      },
      SECURITY: {
        UPDATE: "/app/useraccount/security/password/update/",
      },
    },
    BLOCK: {
      WALLET: {
        LIST: "/block/wallet/list/",
        CREATE: "/block/wallet/create/",
        TXRData: "/block/wallet/info/txr/",
      },
      TOKEN: {
        USER_EXCLUDE: "/block/token/user/exclude/",
        LASTIMPLEMENTED: "/block/token/lastimplemented/",
      },
      ADDRESS: {
        DETAILS: "/block/address/details/",
      },
    },
    FINANCE: {
      TRANSACTION: {
        REGULATOR: "/finance/transaction/regulator/",
        DETAILS: "/finance/transaction/details/",
        LIST: "/finance/transaction/list/",
      },
      IPG: {
        DETAILS: "/finance/ipg/details/",
      },
      ACCOUNT: {
        PRECREATE: "/finance/account/precreate/",
        CREATE: "/finance/account/create/",
        DELETE: "/finance/account/delete/",
        LIST: "/finance/account/list/",
      },
      USERFUND: "/finance/usertotalfund/",
    },
  },
};

export const BLOCKCHAIN = {
  TOKENS: {
    SYMBOL: {
      BITCOIN: "BTC",
      IRANIAN_TOMANS: "IRT",
    },
    EN: {
      BTC: "Bitcoin",
      ETH: "Ethereum",
      GRT: "Graph",
      USDT: "Tether",
      UNI: "Uniswap",
      IRT: "Iranian toman",
    },
    FA: {
      BTC: "بیت کوین",
      ETH: "اتریوم",
      GRT: "گرف",
      USDT: "تتر",
      UNI: "یونی سواپ",
      LTC: "لایت کوین",
      DOGE: "دوج کوین",
      LINK: "چین لینک",
      DAI: "دای",
      SUSHI: "سوشی",
      BCH: "بیت کوین کش",
      TRX: "ترون",
      DOT: "پولکادات",
      XRP: "ریپل",
      XLM: "استلار",
      ADA: "کاردانو",
      AAVE: "آوی",
      IRT: "تومان ایران",
      USD: "دلار آمریکا",
    },
  },
  NETWORKS: {
    RFTP: "RFTP",
    BITCOIN: "Bitcoin",
    ERC20: "ERC20",
  },
};

export const TYPESTATE = {
  STATE: {
    CONFIRMED: "Confirmed",
    FAILED: "Failed",
    PENDING: "Pending",
    REJECTED: "Rejected",
    ACTIVE: "Active",
    SUBMITTED: "Submitted",
    CLOSED: "Closed",
    FA: {
      CONFIRMED: "تایید شده",
      FAILED: "بروز خطا",
      PENDING: "درحال بررسی",
      ACTIVE: "فعال",
      SUBMITTED: "ثبت شده",
    },
  },
  TX: {
    CONFIRMED: "Confirmed",
    FAILED: "Failed",
    PENDING: "Pending",
    ACTIVE: "Active",
    DEPOSIT: "Deposit",
    WITHDRAW: "Withdraw",
    WITHDRAWIMMEDIATE: "WithdrawImmediate",
    BUY: "Buy",
    SELL: "Sell",
    FA: {
      DEPOSIT: "واریز",
      WITHDRAW: "برداشت",
      BUY: "خرید",
      SELL: "فروش",
    },
  },
  TICKET: {
    FA: {
      SUGGESTIONS: "پیشنهادات",
      COMPLAINTS: "شکایات",
      FINANCIAL: "مالی",
      BUGREPORT: "گزارش خطا",
      SUPPORT: "پشتیبانی",
      ANSWERED: "پاسخ داده شده",
      CLOSED: "بسته شده",
    },
  },
};

export const FINANCE = {
  ACCOUNT: {
    EXTERNALWALLET: "External wallet",
    IRANIANBANKS: "Iranian bank",
    CODE: {
      EXTERNALWALLET: "TYPE_FINANCE_ACCOUNT_EXTERNALWALLET",
      IRANIANBANKS: "TYPE_FINANCE_ACCOUNT_IRANIANBANKS",
    },
    FA: {
      EXTERNALWALLET: "کیف پول خارجی",
      IRANIANBANK: "بانک ایران",
    },
  },
};

export const REGEXS = {
  IRANIANBANK: /^([0-9]){16}$/,
};

export const EXTERNALCOMPANY = {
  IRANIANBANKS: {
    SANAT: "627961",
    MELLAT: "610433",
    REFAH: "589463",
    MASKAN: "628023",
    SEPAH: "589210",
    KESHAVARZI: "603770",
    MELLI: "603799",
    TEJARAT: "627353",
    SADERAT: "603769",
    TOSEESADERAT: "627648",
    TOSEETAVON: "628157",
    KARAFARIN: "627488",
    PARSIAN: "622106",
    EGHTESADNOVIN: "627412",
    SAMAN: "621986",
    PASARGAD: "639348",
    SARMAYE: "639607",
    SINA: "639346",
    SHAHR: "502806",
    TAT: "621986",
    ANSAR: "627381",
    DAY: "502938",
    NAMES: {
      FA: {
        SANAT: "صعنت",
        MELLAT: "ملت",
        REFAH: "رفاع",
        MASKAN: "مسکن",
        SEPAH: "سپه",
        KESHAVARZI: "کشاورزی",
        MELLI: "603799",
        TEJARAT: "627353",
        SADERAT: "603769",
        TOSEESADERAT: "627648",
        TOSEETAVON: "628157",
        KARAFARIN: "627488",
        PARSIAN: "622106",
        EGHTESADNOVIN: "627412",
        SAMAN: "621986",
        PASARGAD: "639348",
        SARMAYE: "639607",
        SINA: "639346",
        SHAHR: "502806",
        TAT: "621986",
        ANSAR: "627381",
        DAY: "502938",
      },
    },
  },
};
